/* ============================================================
   CUSTOM: Dovanos auto-add (EasyGift pakaitalas, be app'so).
   Taisykle: krepselyje >=2 prekes (neskaitant pacios dovanos) ->
   Arocell 99% Oneday Booster Ampoule ikrenta automatiskai uz $0.
   Nukritus zemiau 2 -> dovana automatiskai pasalinama.
   TIK retail klientams (wholesale atskiriama per theme.liquid - zr. zemiau).
   Dovana visada nemokama: kaina nuleidziama per Shopify automatine
   "Buy X Get Y / 100% off" nuolaida (sukuriama admin'e), o sis skriptas
   tik uztikrina, kad dovana fiziskai butu krepselyje.
   ============================================================ */
(function () {
  if (!window.NSK_GIFT || !window.NSK_GIFT.variantId) return;

  const GIFT_VARIANT = String(window.NSK_GIFT.variantId);
  const THRESHOLD = 2;
  const PROP_FLAG = "_auto_gift"; // zymeklis, kad atskirtume dovana nuo kliento pirkinio
  let busy = false;

  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then((r) => r.json());
  }

  // skaiciuojam tik NE-dovanos prekiu kieki
  function nonGiftQty(cart) {
    return cart.items.reduce((sum, it) => {
      const isGift = String(it.variant_id) === GIFT_VARIANT || (it.properties && it.properties[PROP_FLAG]);
      return isGift ? sum : sum + it.quantity;
    }, 0);
  }

  function giftLine(cart) {
    return cart.items.find(
      (it) => String(it.variant_id) === GIFT_VARIANT || (it.properties && it.properties[PROP_FLAG])
    );
  }

  function refreshCartUI() {
    try {
      if (window.NextSkyTheme && NextSkyTheme.publish && NextSkyTheme.PUB_SUB_EVENTS) {
        getCart().then((cart) => {
          NextSkyTheme.publish(NextSkyTheme.PUB_SUB_EVENTS.cartUpdate, { source: "auto-gift", cart });
        });
      } else {
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }
    } catch (e) {}
  }

  function addGift() {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(GIFT_VARIANT), quantity: 1, properties: { [PROP_FLAG]: "true" } }] }),
    });
  }

  function removeGift(key) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
  }

  function reconcile() {
    if (busy) return;
    busy = true;
    getCart()
      .then((cart) => {
        if (!cart || !cart.items) return null;
        const qty = nonGiftQty(cart);
        const gift = giftLine(cart);
        if (qty >= THRESHOLD && !gift) {
          return addGift().then(refreshCartUI);
        }
        if (qty < THRESHOLD && gift) {
          return removeGift(gift.key).then(refreshCartUI);
        }
        // jei klientas rankiniu budu padidino dovanos kieki - grazinam i 1
        if (gift && gift.quantity > 1) {
          return fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ id: gift.key, quantity: 1 }),
          }).then(refreshCartUI);
        }
        return null;
      })
      .catch(() => {})
      .finally(() => {
        busy = false;
      });
  }

  // 1) reaguojam i temos krepselio ivykius
  if (window.NextSkyTheme && NextSkyTheme.subscribe && NextSkyTheme.PUB_SUB_EVENTS) {
    NextSkyTheme.subscribe(NextSkyTheme.PUB_SUB_EVENTS.cartUpdate, (data) => {
      if (data && data.source === "auto-gift") return; // vengiam ciklo
      setTimeout(reconcile, 150);
    });
  }
  // 2) atsarginis: po bet kokio /cart uzklausu pokycio per fetch patch
  const origFetch = window.fetch;
  window.fetch = function () {
    const url = arguments[0];
    const p = origFetch.apply(this, arguments);
    if (typeof url === "string" && /\/cart\/(add|change|update)/.test(url) && url.indexOf("change.js") === -1) {
      p.then(() => setTimeout(reconcile, 200)).catch(() => {});
    }
    return p;
  };
  // 3) startas
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", reconcile);
  } else {
    reconcile();
  }
})();
